import React from 'react';

const BusinessAdministration = () => {
  return (
    <div>
      BusinessAdministration
      BusinessAdministration
    </div>
  );
}

export default BusinessAdministration;
